export class CAEmailAddress {
  emailAddress: string;
}
